import {
  dashboardStateFallbackValues,
  useDashboardFilters
} from "@/features/dashboard/DashboardStateContext";
import { ResGetUser } from "@gettactic/api";

export const NoDataMessage = ({ myId }: { myId: ResGetUser["id"] }) => {
  const { filters, setTeams, setOffices, setUsers } = useDashboardFilters();
  const hasTeamsFilter = (filters.teams?.length ?? 0) > 0;
  const hasOfficesFilter = filters.offices.length > 0;
  const hasUsersFilter = (filters.users?.length ?? 0) > 0;
  const onlyUserIsNotMe =
    (filters.users?.length ?? 0) === 1 && (filters.users?.[0] ?? "") !== myId;

  const clearTeams = () => {
    setTeams(dashboardStateFallbackValues.teams);
  };

  const clearOffices = () => {
    setOffices(dashboardStateFallbackValues.offices);
  };

  const clearUsers = () => {
    setUsers(dashboardStateFallbackValues.users);
  };

  const clearAll = () => {
    clearTeams();
    clearOffices();
    clearUsers();
  };

  return (
    <div className="w-full text-sm text-muted-foreground h-full flex flex-col items-center justify-center p-8 text-center">
      <p className="mb-4  font-medium">
        Hmm. Looks like there aren't any team reservations yet this week.
        {/* <Button variant="transparent" onClick={() => {
          setTeams([]);
          setOffices(null);
          setUsers([]);
        }}>Clear all filters</Button>
        {JSON.stringify(filters)} */}
      </p>
      {/* <p className="mb-4 font-sm">
        Once you're in a team and they are reserving workspaces in the office, you'll see their schedules here. Maybe try a different week by using the arrows above.
      </p> */}
      {/* <div className="flex flex-col gap-2">
          {hasTeamsFilter && (
            <p>
              Try <button 
                onClick={clearTeams} 
                className="text-blue-600 hover:underline"
              >
                clearing team filter
              </button>
            </p>
          )}
          {hasOfficesFilter && (
            <p>
              Try <button 
                onClick={clearOffices} 
                className="text-blue-600 hover:underline"
              >
                clearing office filter
              </button>
            </p>
          )}
          {hasUsersFilter && onlyUserIsNotMe && (
            <p>
              Try <button 
                onClick={clearUsers} 
                className="text-blue-600 hover:underline"
              >
                clearing user filter
              </button>
            </p>
          )}
          {(hasTeamsFilter || hasOfficesFilter || hasUsersFilter) && (
            <p>
              Or <button 
                onClick={clearAll} 
                className="text-blue-600 hover:underline"
              >
                clear all filters
              </button>
            </p>
          )}
        </div> */}
    </div>
  );
};
